<div
  *transloco="let t; read: 'widgets.grid-analytic-item-selector-dialog'"
  class="xi-modal__container grid-analytic-item-selector-dialog__container"
>
  <h1 class="xi-modal__title kxi-text-xlarge text-center">
    {{ t('title') }}
  </h1>

  <form [formGroup]="form" class="grid-analytic-item-selector-dialog__form grid-analytic-item-main">
    <div
      class="grid-analytic-item-selector-dialog__row grid-analytic-item-selector-dialog__top-row breakdown-select-row"
    >
      <div
        class="grid-analytic-item-selector-dialog__breakdown-row breakdown-select-row"
        [class.__extra-margin]="showBreakdownDateConfig"
      >
        <xi-dropdown
          [label]="t('select-breakdown-field')"
          [placeholder]="t('select')"
          [data]="keywordFieldSet"
          select="single"
          formControlName="breakdownField"
        ></xi-dropdown>

        @if (!isNoBreakdown) {
          <xi-input-field
            [label]="t('breakdown-label')"
            [placeholder]="t('label')"
            formControlName="breakdownLabel"
            icon="cancel_circle"
            (onIconClick)="onBreakdownLabelIconClick()"
          ></xi-input-field>

          <xi-dropdown
            [label]="t('display-using')"
            [placeholder]="t('select')"
            [data]="keywordFieldSet"
            select="single"
            formControlName="displayField"
          ></xi-dropdown>

          <xi-checkbox
            [label]="t('include-blank')"
            formControlName="includeBlank"
            color="CX"
          ></xi-checkbox>
          <xi-checkbox
            [label]="t('use-metadata-display-name')"
            formControlName="useDisplayName"
            color="CX"
          ></xi-checkbox>
        }
      </div>
    </div>

    <div class="numeric-metadata-row">
      <app-numeric-metadata-field-selector
        [fields]="numericFields"
        [rows]="options.widget.payload.numericMetadataFields"
        [hasSettings]="false"
        [canSetColor]="false"
        [canSetDecimals]="false"
        [sentimentScale]="options.sentimentScale"
        (valueChange)="onNumericMetadataFieldsChanged($event)"
        (isValid)="onNumericMetadataFieldsIsValid($event)"
      ></app-numeric-metadata-field-selector>
    </div>

    <div class="breakdown-config-column">
      <h3 class="text-center bold">{{ t('breakdown-configuration') }}</h3>
      @if (showBreakdownDateConfig) {
        <app-grid-breakdown-date-config
          [widget]="options.widget"
          [widgetDataSource]="options.widgetDataSource"
          [value]="options.widget.payload?.dateInterval"
          (onValueChange)="onBreakdownDateConfigChanged($event)"
        ></app-grid-breakdown-date-config>
      }
      @if (showTaxonomyPicker) {
        <app-grid-breakdown-taxonomy-config
          [projectId]="options.widget.payload.projectId"
          [widgetDataSource]="options.widgetDataSource"
          [taxonomyPayload]="options.widget.payload.taxonomyOptions"
          (isValid)="onTaxonomyOptionsValid($event)"
          (onValueChange)="onTaxonomyOptionsChanged($event)"
        ></app-grid-breakdown-taxonomy-config>
      }

      <div
        class="grid-analytic-item-selector-dialog__row grid-analytic-item-selector-dialog__bottom-row"
      >
        <span class="kxi-label">{{ t('display-totals') }}</span>

        <span class="kxi-label">{{ t('with-label') }}</span>

        <xi-checkbox
          [label]="t('show-all')"
          formControlName="showAll"
          color="CX"
          class="grid-analytic-item-selector-dialog__show"
          [matTooltip]="totalsDisabledTooltip"
          matTooltipPosition="above"
        ></xi-checkbox>

        <div>
          @if (form.controls.showAll.value || isTotalsDisabled) {
            <xi-input-field
              formControlName="allLabel"
              [disabled]="isTotalsDisabled"
            ></xi-input-field>
          }
        </div>

        <xi-checkbox
          [label]="t('show-top-n', { value: GRID_TOP_N })"
          formControlName="showTopN"
          color="CX"
          class="grid-analytic-item-selector-dialog__show"
          [matTooltip]="totalsDisabledTooltip"
          matTooltipPosition="above"
        ></xi-checkbox>

        <div>
          @if (form.controls.showTopN.value || isTotalsDisabled) {
            <xi-input-field
              formControlName="topNLabel"
              [disabled]="isTotalsDisabled"
            ></xi-input-field>
          }
        </div>
      </div>
    </div>
  </form>

  <div class="xi-modal__actions">
    <xi-default-button
      [text]="t('cancel', { isNew: options.isNew })"
      fill="text"
      (onClick)="onCancel()"
    ></xi-default-button>

    <xi-default-button
      [text]="t('save', { isNew: options.isNew })"
      [disabled]="isInvalid"
      (onClick)="onSave()"
    ></xi-default-button>
  </div>
</div>
